import { Tab } from '@headlessui/react'
import classNames from 'classnames'

import classIcon from '@/assets/icons/Rectangle 15.png'
import journalIcon from '@/assets/icons/Rectangle 16.png'
import chatIcon from '@/assets/icons/Rectangle 17.png'
import quizIcon from '@/assets/icons/Rectangle 18.png'
import vedioIcon from '@/assets/icons/Rectangle 19.png'

const tabs = ['METHODOLOGY']

const methodology = [
  {
    id: 0,
    imgUrl: `${classIcon.src}`,
    title: 'GROUP CLASS',
    desc: 'Creating a support network for engaged learning',
  },
  {
    id: 1,
    imgUrl: `${journalIcon.src}`,
    title: 'ASSISTED JOURNALS',
    desc: 'For aided awareness and practise',
  },
  {
    id: 2,
    imgUrl: `${chatIcon.src}`,
    title: 'LIVE CHAT',
    desc: 'During live sessions for experiential learning',
  },
  {
    id: 3,
    imgUrl: `${quizIcon.src}`,
    title: 'QUIZZES & GAMES',
    desc: 'To aid reflection, recall and just for fun',
  },
  {
    id: 4,
    imgUrl: `${vedioIcon.src}`,
    title: 'RECORDED VIDEO ACCESS',
    desc: 'All lessons for a year',
  },
]

const Methodology = () => {
  return (
    <div className='mx-auto w-full pb-14'>
      <Tab.Group as='div'>
        <div className='custom-font border-b border-gray-200'>
          <Tab.List className='mb-2y flex space-x-8'>
            {tabs.map((tab) => (
              <Tab
                key={tab}
                className={({ selected }) =>
                  classNames(
                    selected
                      ? 'custom-font my-7 border-gray-600 font-bold uppercase text-gray-900'
                      : 'border-transparent font-bold text-gray-900 hover:border-gray-300 hover:text-gray-800',
                    'custom-font whitespace-nowrap py-3 uppercase',
                  )
                }
              >
                <span className='border-custom '>{tab}</span>
              </Tab>
            ))}
          </Tab.List>
        </div>
        <Tab.Panels>
          {methodology.map((item, itemIdx) => (
            <div key={item.id} className='my-5 flex space-x-4'>
              <div className='flex-w-69 mx-[15px] self-center'>
                <img src={item.imgUrl} alt='' className='img-w-69 ' />
              </div>
              <div className='py-2'>
                <h3 className='group-tab-font font-bold text-[#333333]'>
                  {item.title}
                </h3>
                <p className='group-des-font text-[#808080]'>{item.desc}</p>
              </div>
            </div>
          ))}
        </Tab.Panels>
      </Tab.Group>
      <style jsx>{`
        .border-custom::before {
          content: '';
          width: calc(30px + (65 - 30) * (100vw - 375px) / (1920 - 375));
          height: 1px;
          background-color: #4b5563;
          position: absolute;
          margin-top: calc(28px + (43 - 28) * (100vw - 375px) / (1920 - 375));
        }
        .custom-font {
          font-size: calc(16px + (30 - 16) * (100vw - 375px) / (1920 - 375));
        }
        .group-tab-font {
          font-size: calc(14px + (28 - 14) * (100vw - 375px) / (1920 - 375));
        }
        .group-des-font {
          font-size: calc(12px + (24 - 12) * (100vw - 375px) / (1920 - 375));
        }
      `}</style>
    </div>
  )
}

export default Methodology
